export const env = {
    isWeibo() {
        return /weibo/.test(navigator.userAgent.toLowerCase())
    },
    isWxApp() {
        return /miniprogram/.test(navigator.userAgent.toLowerCase())
    },
    isWeixin() {
        return /micromessenger/.test(navigator.userAgent.toLowerCase())
    },
    isToutiao() {
        return /toutiaomicroapp/.test(navigator.userAgent.toLowerCase())
    },
    isIos() {
        return /ipad|ipod|iphone/.test(navigator.userAgent.toLowerCase())
    },
    isMobile() {
        return /android|symbianos|windows phone|ipad|ipod|iphone/.test(navigator.userAgent.toLowerCase())
    },
    isIphoneX() {
        return (
            /iphone/.test(navigator.userAgent.toLowerCase()) &&
            ((812 === screen.height && 375 === screen.width) || (896 === screen.height && 414 === screen.width))
        )
    },
    //判断是不是 iphone safari
    isSafari() {
        return /iphone/.test(navigator.userAgent.toLowerCase()) && /safari/.test(navigator.userAgent.toLowerCase())
    },
    isModianIos() {
        return /ios-modian/.test(navigator.userAgent.toLowerCase())
    },
    isModianAndroid() {
        return /android-modian/.test(navigator.userAgent.toLowerCase())
    },
    isModianIosNew() {
        return /ios-modian-wk/.test(navigator.userAgent.toLowerCase())
    },
}
export default env

export const isIphoneX = env.isIphoneX

export const domTop = () => document.documentElement.scrollTop || document.body.scrollTop

export const domHeight = () => document.documentElement.scrollHeight || document.body.scrollHeight

export const domClientWidth = () => document.documentElement.clientWidth || document.body.clientWidth

export const domClientHeight = () => document.documentElement.clientHeight || document.body.clientHeight

export const domPixelRatio = () => window.devicePixelRatio || 2 // 设备像素比

// 神策打点属性
export const sensorsParams = (() => {
    let client = 3
    let md_client = 'wap'
    let platform_type = "other"
    let channel = ''
    if (env.isMobile()) {
        client = 3
        if (env.isModianIos()) { // ios
            md_client = 'ios'
            channel = 'ios'
        }else if (env.isModianAndroid()) { // android
            md_client = 'android'
            channel = 'android'
        } else if (env.isWeibo()) { // 微博
            platform_type = "weibo"
            md_client = "weibo"
            channel = 'weibo'
        } else if (sessionStorage.getItem("miniProgram") || env.isWxApp() ) { // 小程序
            // 头条
            if (sessionStorage.getItem("miniProgram") == "toutiao") {
              md_client = "toutiao_mina"
              channel = "tt-mina"
            } else {
              platform_type = "weixin"
              md_client = "mina"
              channel = "wx-mina" 
            }
        } else if (env.isWeixin()) { //微信浏览器
            platform_type = "weixin"
            channel = 'wx-browser'
        }
    }
    return {
        client: client,
        md_client: md_client,
        platform_type: platform_type,
        channel: channel,
        build: 993322221
    }
})()
